/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IColumn, SelectionMode } from '@fluentui/react/lib/DetailsList';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { Table } from 'src/core/components/Table';
import { TableProps } from 'src/core/components/TableProps';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { AzureTenantStore } from 'src/core/stores/AzureTenantStore';

const messages = defineMessages({
    nameColumnHeader: {
        id: 'portal.directoriesTable.nameColumnHeader',
        defaultMessage: 'Directory name'
    },
    domainColumnHeader: {
        id: 'portal.directoriesTable.domainColumnHeader',
        defaultMessage: 'Domain'
    }
});

export const DirectoriesTable = (props: TableProps<AzureTenantStore>) => {
    const { items, sortKey, ...rest } = props;

    const { localize } = useLocalization();

    const columns: IColumn[] = [
        {
            key: 'name',
            minWidth: 300,
            maxWidth: 600,
            fieldName: 'name',
            isResizable: true,
            isSorted: sortKey?.key === 'name',
            name: localize(messages.nameColumnHeader),
            onRender: (item: AzureTenantStore) => <LuisText>{item.name}</LuisText>,
            isSortedDescending: sortKey?.key === 'name' && sortKey?.order === 'desc'
        },
        {
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
            key: 'defaultDomain',
            fieldName: 'defaultDomain',
            isSorted: sortKey?.key === 'defaultDomain',
            name: localize(messages.domainColumnHeader),
            onRender: (item: AzureTenantStore) => <LuisText>{item.defaultDomain}</LuisText>,
            isSortedDescending: sortKey?.key === 'defaultDomain' && sortKey?.order === 'desc'
        }
    ];

    return <Table<AzureTenantStore> items={items} shimmerLines={3} columns={columns} selectionMode={SelectionMode.single} {...rest} />;
};
